// Reusable export components — the FE half of the shared contract. Mirrors
// export-runner/src/render/components/contract.ts. Everything a component needs
// lives under the TipTap node's `attrs` (config/data/sourceId/layout) because the
// runner's FreeformNodeSchema strips every root key except {type, attrs, …}. The
// node uses `type: 'reusableComponent'` and NEVER a top-level `kind` (that would
// misroute it into the runner's renderBlock path). See
// wiki/notes/reusable-export-componnets.md.

export const REUSABLE_COMPONENT_NODE_TYPE = 'reusableComponent';

export type WidthPreset = 'full' | 'twoThirds' | 'half' | 'third' | 'quarter' | 'auto' | 'custom';

export interface ReusableLayout {
  // Fraction of the page content width, 0..1. Single source of truth for width.
  widthFraction: number;
  widthPreset: WidthPreset;
  align?: 'left' | 'center' | 'right';
}

export interface ReusableComponentAttrs {
  /** Registry id, e.g. 'assessmentExpectedLoss'. Stable forever. */
  component: string;
  /** Config schema version for lazy migration. */
  version: number;
  /** User-tunable settings (per-component shape). */
  config: Record<string, unknown>;
  /** Precomputed render data, passed from the FE today. */
  data: Record<string, unknown> | null;
  /** Handle for the FUTURE runner-side fetch by id; FE data wins until then. */
  sourceId: string | null;
  /** Layout / sizing. Phase 1 is always full width. */
  layout: ReusableLayout;
}

// Phase 1 ships full-width only; sizing UI (presets + edge-drag) is phase 2.
export const DEFAULT_LAYOUT: ReusableLayout = { widthFraction: 1, widthPreset: 'full', align: 'left' };
